// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { FaPlus } from "react-icons/fa";
// import {
//   Modal,
//   Button,
//   Form,
//   Table,
//   Pagination,
//   Row,
//   Col,
//   Container,
// } from "react-bootstrap";
// import { FaEdit } from "react-icons/fa";
// import { RiDeleteBin3Fill } from "react-icons/ri";
// import { HiOutlineChevronLeft, HiChevronRight } from "react-icons/hi2";
// import { BsThreeDots } from "react-icons/bs";

// const API_URL = process.env.REACT_APP_API_URL;

// function CategoryList() {
//   const navigate = useNavigate();
//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);

//   const [editModalData, setEditModalData] = useState({
//     show: false,
//     id: null,
//     name: "",
//   });
//   const [deleteModalData, setDeleteModalData] = useState({
//     show: false,
//     id: null,
//     name: "",
//   });
//   const [actionLoading, setActionLoading] = useState(false);
//   const [showToast, setShowToast] = useState(false);
//   const [toastMessage, setToastMessage] = useState("");
//   const [toastVariant, setToastVariant] = useState("success");

//   const getAuthToken = () => {
//     return localStorage.getItem("token");
//   };

//   const showToastMessage = (message, variant) => {
//     setToastMessage(message);
//     setToastVariant(variant);
//     setShowToast(true);
//   };

//   const fetchCategories = async (page = 1) => {
//     setLoading(true);
//     const token = getAuthToken();
//     if (!token) {
//       setError("Authentication token not found. Please log in.");
//       setLoading(false);
//       return;
//     }

//     try {
//       const response = await fetch(
//         `${API_URL}/expence-category-list?page=${page}&limit=10`,
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         },
//       );

//       if (!response.ok) {
//         if (response.status === 401) {
//           navigate("/login");
//         }
//         throw new Error("Failed to fetch categories.");
//       }

//       const data = await response.json();
//       if (data.status) {
//         setCategories(data.data);
//         setTotalPages(data.totalPages || 1);
//         setCurrentPage(data.currentPage || page);
//       } else {
//         setError(data.message || "No categories found.");
//         setCategories([]);
//       }
//     } catch (err) {
//       console.error("Fetch error:", err);
//       setError(err.message);
//       setCategories([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchCategories(currentPage);
//   }, [currentPage]);

//   const handleEditClick = (category) => {
//     setEditModalData({
//       show: true,
//       id: category.id,
//       name: category.name,
//     });
//   };

//   const handleDeleteClick = (category) => {
//     setDeleteModalData({
//       show: true,
//       id: category.id,
//       name: category.name,
//     });
//   };

//   const handleEditModalClose = () => {
//     setEditModalData({ show: false, id: null, name: "" });
//   };

//   const handleDeleteModalClose = () => {
//     setDeleteModalData({ show: false, id: null, name: "" });
//   };

//   const handleEditFormChange = (e) => {
//     setEditModalData({ ...editModalData, name: e.target.value });
//   };

//   const handleUpdateCategory = async (e) => {
//     e.preventDefault();
//     if (!editModalData.name.trim()) {
//       showToastMessage("Category name cannot be empty.", "danger");
//       return;
//     }

//     setActionLoading(true);
//     const token = getAuthToken();

//     try {
//       const payload = {
//         id: editModalData.id,
//         name: editModalData.name,
//       };

//       const response = await fetch(`${API_URL}/expence-category-update`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(payload),
//       });

//       const result = await response.json();

//       console.log(result);

//       if (result.success == "1") {
//         showToastMessage("Category updated successfully!", "success");
//         handleEditModalClose();
//         fetchCategories();
//       } else {
//         throw new Error(result.message || "Failed to update category.");
//       }
//     } catch (err) {
//       console.error("Update error:", err);
//       showToastMessage(err.message, "danger");
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   const handleDeleteCategory = async () => {
//     setActionLoading(true);
//     const token = getAuthToken();

//     try {
//       const payload = {
//         id: deleteModalData.id,
//       };

//       const response = await fetch(`${API_URL}/expence-category-delete`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(payload),
//       });

//       const result = await response.json();
//       if (response.ok && result.status) {
//         showToastMessage("Category deleted successfully!", "success", "top");
//         handleDeleteModalClose();
//         fetchCategories();
//       } else {
//         throw new Error(result.message || "Failed to delete category.");
//       }
//     } catch (err) {
//       console.error("Delete error:", err);
//       showToastMessage(err.message, "danger", "top");
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   const handlePageChange = (pageNumber) => {
//     if (pageNumber >= 1 && pageNumber <= totalPages) {
//       fetchCategories(pageNumber);
//     }
//   };

//   // return (
//   //   <div>
//   //     <div className="card mt-2">
//   //       <div className="card-header">
//   //         <div className="d-flex justify-content-between align-items-center">
//   //           <div className="titlepage">
//   //             <h3 className="mb-0">Expense Categories</h3>
//   //           </div>
//   //           <Link to="/add-category" className="btn btn-primary">
//   //             <FaPlus className="me-2" />
//   //             Add Category
//   //           </Link>
//   //         </div>
//   //       </div>
//   //       <div className="card-body">
//   //         {loading ? (
//   //           <div className="text-center mt-5">
//   //             <div className="spinner-border text-primary" role="status">
//   //               <span className="visually-hidden">Loading...</span>
//   //             </div>
//   //             <p>Loading categories...</p>
//   //           </div>
//   //         ) : error ? (
//   //           <div className="alert alert-danger" role="alert">
//   //             {error}
//   //           </div>
//   //         ) : categories?.length == 0 ? (
//   //           <div className="alert alert-info" role="alert">
//   //             No expense categories found.
//   //           </div>
//   //         ) : (
//   //           <div>
//   //             <Table striped bordered hover responsive>
//   //               <thead>
//   //                 <tr>
//   //                   <th>#</th>
//   //                   <th>Name</th>
//   //                   <th>Category Type</th>
//   //                   <th>Created At</th>
//   //                   <th>Actions</th>
//   //                 </tr>
//   //               </thead>
//   //               <tbody>
//   //                 {categories?.map((category, index) => (
//   //                   <tr key={category.id}>
//   //                     <td>{(currentPage - 1) * 10 + index + 1}</td>
//   //                     <td
//   //                       style={{
//   //                         textAlign: "justify",
//   //                         whiteSpace: "normal",
//   //                         wordWrap: "break-word",
//   //                         wordBreak: "break-word",
//   //                       }}
//   //                     >
//   //                       {category.name.charAt(0).toUpperCase() +
//   //                         category.name.slice(1).toLowerCase()}
//   //                     </td>

//   //                     <td>{category.type || "NA"}</td>
//   //                     <td>
//   //                       {new Date(category.created_at)
//   //                         .toLocaleDateString("en-GB")
//   //                         .replace(/\//g, "-")}
//   //                     </td>
//   //                     <td>
//   //                       <div className="dropdown">
//   //                         <button
//   //                           className="btn light btn-action dropdown-toggle"
//   //                           type="button"
//   //                           id="dropdownMenuButton"
//   //                           data-bs-toggle="dropdown"
//   //                           aria-expanded="false"
//   //                         >
//   //                           <BsThreeDots size={20} />
//   //                         </button>

//   //                         <ul
//   //                           className="dropdown-menu"
//   //                           aria-labelledby="dropdownMenuButton"
//   //                         >
//   //                           <li className="dropdown-item">
//   //                             <button
//   //                               className="btn edit_btn btn-sm me-1"
//   //                               onClick={() => handleEditClick(category)}
//   //                               title="Edit Project"
//   //                             >
//   //                               <FaEdit /> Edit
//   //                             </button>
//   //                           </li>

//   //                           <li className="dropdown-item">
//   //                             <button
//   //                               className="btn delete_btn btn-sm"
//   //                               onClick={() => handleDeleteClick(category)}
//   //                               title="Delete Project"
//   //                             >
//   //                               <RiDeleteBin3Fill /> Delete
//   //                             </button>
//   //                           </li>
//   //                         </ul>
//   //                       </div>
//   //                     </td>
//   //                   </tr>
//   //                 ))}
//   //               </tbody>
//   //             </Table>

//   //             <div className="d-flex justify-content-end">
//   //               <Pagination>
//   //                 <Pagination.Prev
//   //                   onClick={() => handlePageChange(currentPage - 1)}
//   //                   disabled={currentPage === 1}
//   //                 />
//   //                 {[...Array(totalPages)].map((_, index) => (
//   //                   <Pagination.Item
//   //                     key={index + 1}
//   //                     active={index + 1 === currentPage}
//   //                     onClick={() => handlePageChange(index + 1)}
//   //                   >
//   //                     {index + 1}
//   //                   </Pagination.Item>
//   //                 ))}
//   //                 <Pagination.Next
//   //                   onClick={() => handlePageChange(currentPage + 1)}
//   //                   disabled={currentPage === totalPages}
//   //                 />
//   //               </Pagination>
//   //             </div>
//   //           </div>
//   //         )}
//   //       </div>
//   //     </div>
//   //     <Modal show={editModalData.show} onHide={handleEditModalClose}>
//   //       <Modal.Header closeButton>
//   //         <Modal.Title>Edit Category</Modal.Title>
//   //       </Modal.Header>
//   //       <Form onSubmit={handleUpdateCategory}>
//   //         <Modal.Body>
//   //           <Form.Group className="mb-3">
//   //             <Form.Label>Category Name</Form.Label>
//   //             <Form.Control
//   //               type="text"
//   //               value={editModalData.name}
//   //               onChange={handleEditFormChange}
//   //               required
//   //             />
//   //           </Form.Group>
//   //         </Modal.Body>

//   //         <Modal.Footer>
//   //           <Button variant="danger" onClick={handleEditModalClose}>
//   //             Close
//   //           </Button>
//   //           <Button variant="primary" type="submit" disabled={actionLoading}>
//   //             {actionLoading ? "Updating..." : "Save Changes"}
//   //           </Button>
//   //         </Modal.Footer>
//   //       </Form>
//   //     </Modal>

//   //     <Modal show={deleteModalData.show} onHide={handleDeleteModalClose}>
//   //       <Modal.Header closeButton>
//   //         <Modal.Title>Confirm Deletion</Modal.Title>
//   //       </Modal.Header>
//   //       <Modal.Body>
//   //         Are you sure you want to delete the category "
//   //         <strong>{deleteModalData.name}</strong>"? This action cannot be
//   //         undone.
//   //       </Modal.Body>
//   //       <Modal.Footer>
//   //         <Button variant="secondary" onClick={handleDeleteModalClose}>
//   //           Cancel
//   //         </Button>
//   //         <Button
//   //           variant="danger"
//   //           onClick={handleDeleteCategory}
//   //           disabled={actionLoading}
//   //         >
//   //           {actionLoading ? "Deleting..." : "Delete"}
//   //         </Button>
//   //       </Modal.Footer>
//   //     </Modal>

//   //     {showToast && (
//   //       <div
//   //         className={`toast show bg-${toastVariant} text-white`}
//   //         style={{ position: "fixed", bottom: "20px", right: "20px" }}
//   //         role="alert"
//   //         aria-live="assertive"
//   //         aria-atomic="true"
//   //       >
//   //         <div className="toast-header bg-transparent text-white border-0">
//   //           <strong className="me-auto">
//   //             {toastVariant === "success" ? "Success" : "Error"}
//   //           </strong>
//   //           <button
//   //             type="button"
//   //             className="btn-close btn-close-white"
//   //             onClick={() => setShowToast(false)}
//   //             aria-label="Close"
//   //           ></button>
//   //         </div>
//   //         <div className="toast-body">{toastMessage}</div>
//   //       </div>
//   //     )}
//   //   </div>
//   // );
//   return (
//     <>
//       <div
//         style={{
//           minHeight: "100vh",
//           background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//           padding: "30px 24px",
//           fontFamily: "'Poppins', 'DM Sans', sans-serif",
//         }}
//       >
//         <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
//           {/* 🎯 HEADER CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               padding: "20px 24px",
//               display: "flex",
//               alignItems: "center",
//               gap: "16px",
//               marginBottom: "20px",
//               flexWrap: "wrap",
//             }}
//           >
//             <div
//               style={{
//                 width: "52px",
//                 height: "52px",
//                 borderRadius: "14px",
//                 background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 color: "#ffffff",
//                 fontSize: "24px",
//                 boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
//                 flexShrink: 0,
//               }}
//             >
//               🏷️
//             </div>
//             <div style={{ flex: 1, minWidth: "200px" }}>
//               <h1
//                 style={{
//                   margin: 0,
//                   fontSize: "24px",
//                   fontWeight: "800",
//                   color: "#1e3a5f",
//                   letterSpacing: "-0.5px",
//                 }}
//               >
//                 Expense Categories
//               </h1>
//               <p
//                 style={{
//                   margin: "2px 0 0",
//                   fontSize: "13px",
//                   color: "#64748b",
//                   fontWeight: "500",
//                 }}
//               >
//                 Manage all expense categories in one place
//               </p>
//             </div>

//             <Link to="/add-category" className="btn btn-primary">
//               <FaPlus className="me-2" /> Add Category
//             </Link>
//           </div>

//           {/* 🎯 MAIN CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               overflow: "hidden",
//             }}
//           >
//             <div
//               style={{
//                 height: "5px",
//                 background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
//               }}
//             />

//             <div style={{ padding: "30px" }}>
//               {loading ? (
//                 <div className="text-center my-5">
//                   <div className="spinner-border text-primary" role="status">
//                     <span className="visually-hidden">Loading...</span>
//                   </div>
//                   <p className="mt-3">Loading categories...</p>
//                 </div>
//               ) : error ? (
//                 <div className="alert alert-danger" role="alert">
//                   {error}
//                 </div>
//               ) : categories?.length === 0 ? (
//                 <div className="alert alert-info" role="alert">
//                   No expense categories found.
//                 </div>
//               ) : (
//                 <div>
//                   <Table striped bordered hover responsive>
//                     <thead>
//                       <tr>
//                         <th>#</th>
//                         <th>Name</th>
//                         <th>Category Type</th>
//                         <th>Created At</th>
//                         <th>Actions</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {categories?.map((category, index) => (
//                         <tr key={category.id}>
//                           <td>{(currentPage - 1) * 10 + index + 1}</td>
//                           <td
//                             style={{
//                               textAlign: "justify",
//                               whiteSpace: "normal",
//                               wordWrap: "break-word",
//                               wordBreak: "break-word",
//                             }}
//                           >
//                             {category.name.charAt(0).toUpperCase() +
//                               category.name.slice(1).toLowerCase()}
//                           </td>
//                           <td>{category.type || "NA"}</td>
//                           <td>
//                             {new Date(category.created_at)
//                               .toLocaleDateString("en-GB")
//                               .replace(/\//g, "-")}
//                           </td>
//                           <td>
//                             <div className="dropdown">
//                               <button
//                                 className="btn light btn-action dropdown-toggle"
//                                 type="button"
//                                 id="dropdownMenuButton"
//                                 data-bs-toggle="dropdown"
//                                 aria-expanded="false"
//                               >
//                                 <BsThreeDots size={20} />
//                               </button>
//                               <ul
//                                 className="dropdown-menu"
//                                 aria-labelledby="dropdownMenuButton"
//                               >
//                                 <li className="dropdown-item">
//                                   <button
//                                     className="btn edit_btn btn-sm me-1"
//                                     onClick={() => handleEditClick(category)}
//                                     title="Edit Category"
//                                   >
//                                     <FaEdit /> Edit
//                                   </button>
//                                 </li>
//                                 <li className="dropdown-item">
//                                   <button
//                                     className="btn delete_btn btn-sm"
//                                     onClick={() => handleDeleteClick(category)}
//                                     title="Delete Category"
//                                   >
//                                     <RiDeleteBin3Fill /> Delete
//                                   </button>
//                                 </li>
//                               </ul>
//                             </div>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </Table>

//                   {/* Pagination */}
//                   <div className="d-flex justify-content-end">
//                     <Pagination>
//                       <Pagination.Prev
//                         onClick={() => handlePageChange(currentPage - 1)}
//                         disabled={currentPage === 1}
//                       />
//                       {[...Array(totalPages)].map((_, index) => (
//                         <Pagination.Item
//                           key={index + 1}
//                           active={index + 1 === currentPage}
//                           onClick={() => handlePageChange(index + 1)}
//                         >
//                           {index + 1}
//                         </Pagination.Item>
//                       ))}
//                       <Pagination.Next
//                         onClick={() => handlePageChange(currentPage + 1)}
//                         disabled={currentPage === totalPages}
//                       />
//                     </Pagination>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>

//           {/* Footer Copyright */}
//           <p
//             style={{
//               textAlign: "center",
//               color: "#94a3b8",
//               fontSize: "12.5px",
//               marginTop: "24px",
//               fontWeight: "500",
//             }}
//           >
//             © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
//             Rights Reserved.
//           </p>
//         </div>
//       </div>

//       {/* Edit Modal */}
//       <Modal show={editModalData.show} onHide={handleEditModalClose} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Edit Category</Modal.Title>
//         </Modal.Header>
//         <Form onSubmit={handleUpdateCategory}>
//           <Modal.Body>
//             <Form.Group className="mb-3">
//               <Form.Label>Category Name</Form.Label>
//               <Form.Control
//                 type="text"
//                 value={editModalData.name}
//                 onChange={handleEditFormChange}
//                 required
//               />
//             </Form.Group>
//           </Modal.Body>
//           <Modal.Footer>
//             <Button variant="danger" onClick={handleEditModalClose}>
//               Close
//             </Button>
//             <Button variant="primary" type="submit" disabled={actionLoading}>
//               {actionLoading ? "Updating..." : "Save Changes"}
//             </Button>
//           </Modal.Footer>
//         </Form>
//       </Modal>

//       {/* Delete Confirmation Modal */}
//       <Modal
//         show={deleteModalData.show}
//         onHide={handleDeleteModalClose}
//         centered
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Confirm Deletion</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           Are you sure you want to delete the category "
//           <strong>{deleteModalData.name}</strong>"? This action cannot be
//           undone.
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleDeleteModalClose}>
//             Cancel
//           </Button>
//           <Button
//             variant="danger"
//             onClick={handleDeleteCategory}
//             disabled={actionLoading}
//           >
//             {actionLoading ? "Deleting..." : "Delete"}
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Toast */}
//       {showToast && (
//         <div
//           className={`toast show bg-${toastVariant} text-white`}
//           style={{
//             position: "fixed",
//             bottom: "20px",
//             right: "20px",
//             zIndex: 9999,
//             borderRadius: "12px",
//             overflow: "hidden",
//             boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
//           }}
//           role="alert"
//           aria-live="assertive"
//           aria-atomic="true"
//         >
//           <div className="toast-header bg-transparent text-white border-0">
//             <strong className="me-auto">
//               {toastVariant === "success" ? "Success" : "Error"}
//             </strong>
//             <button
//               type="button"
//               className="btn-close btn-close-white"
//               onClick={() => setShowToast(false)}
//               aria-label="Close"
//             ></button>
//           </div>
//           <div className="toast-body">{toastMessage}</div>
//         </div>
//       )}
//     </>
//   );
  
// }

// export default CategoryList;

import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaPlus, FaEdit } from "react-icons/fa";
import { Modal, Form } from "react-bootstrap";
import { RiDeleteBin3Fill } from "react-icons/ri";
import { BsThreeDots } from "react-icons/bs";
import Swal from "sweetalert2";

const API_URL = process.env.REACT_APP_API_URL;
const LIMIT = 10;

function CategoryList() {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [actionLoading, setActionLoading] = useState(false);

  const [editModalData, setEditModalData] = useState({
    show: false,
    id: null,
    name: "",
  });

  const [deleteModalData, setDeleteModalData] = useState({
    show: false,
    id: null,
    name: "",
  });

  const getAuthToken = () => localStorage.getItem("token");

  // ═══════════════════════════════════════════
  // 🔹 FETCH CATEGORIES (Server-Side Pagination)
  // ═══════════════════════════════════════════
  const fetchCategories = async (page = 1) => {
    setLoading(true);
    setError(null);
    const token = getAuthToken();
    if (!token) {
      setError("Authentication token not found. Please log in.");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(
        `${API_URL}/expence-category-list?page=${page}&limit=${LIMIT}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        if (response.status === 401) {
          navigate("/login");
        }
        throw new Error("Failed to fetch categories.");
      }

      const data = await response.json();
      if (data.status) {
        setCategories(data.data || []);

        const pages = Number(data.totalPages) || 1;
        const total = Number(data.total) || (data.data?.length || 0);

        setTotalPages(pages);
        setTotalItems(total);
        setCurrentPage(Number(data.currentPage) || Number(page));
      } else {
        setError(data.message || "No categories found.");
        setCategories([]);
        setTotalPages(1);
        setTotalItems(0);
      }
    } catch (err) {
      console.error("Fetch error:", err);
      setError(err.message);
      setCategories([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories(currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
  };

  // ═══════════════════════════════════════════
  // 🔹 EDIT
  // ═══════════════════════════════════════════
  const handleEditClick = (category) => {
    setEditModalData({
      show: true,
      id: category.id,
      name: category.name,
    });
  };

  const handleEditModalClose = () => {
    setEditModalData({ show: false, id: null, name: "" });
  };

  const handleEditFormChange = (e) => {
    setEditModalData({ ...editModalData, name: e.target.value });
  };

  const handleUpdateCategory = async (e) => {
    e.preventDefault();
    if (!editModalData.name.trim()) {
      Swal.fire("Warning", "Category name cannot be empty.", "warning");
      return;
    }

    setActionLoading(true);
    const token = getAuthToken();

    try {
      const payload = {
        id: editModalData.id,
        name: editModalData.name,
      };

      const response = await fetch(`${API_URL}/expence-category-update`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (result.success == "1") {
        Swal.fire({
          icon: "success",
          title: "Updated!",
          text: "Category updated successfully!",
          timer: 1600,
          showConfirmButton: false,
        });
        handleEditModalClose();
        fetchCategories(currentPage);
      } else {
        throw new Error(result.message || "Failed to update category.");
      }
    } catch (err) {
      console.error("Update error:", err);
      Swal.fire("Error", err.message, "error");
    } finally {
      setActionLoading(false);
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 DELETE
  // ═══════════════════════════════════════════
  const handleDeleteClick = (category) => {
    setDeleteModalData({
      show: true,
      id: category.id,
      name: category.name,
    });
  };

  const handleDeleteModalClose = () => {
    setDeleteModalData({ show: false, id: null, name: "" });
  };

  const handleDeleteCategory = async () => {
    setActionLoading(true);
    const token = getAuthToken();

    try {
      const payload = { id: deleteModalData.id };

      const response = await fetch(`${API_URL}/expence-category-delete`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      if (response.ok && result.status) {
        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "Category deleted successfully!",
          timer: 1600,
          showConfirmButton: false,
        });
        handleDeleteModalClose();
        fetchCategories(currentPage);
      } else {
        throw new Error(result.message || "Failed to delete category.");
      }
    } catch (err) {
      console.error("Delete error:", err);
      Swal.fire("Error", err.message, "error");
    } finally {
      setActionLoading(false);
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 PAGINATION PAGES
  // ═══════════════════════════════════════════
  const getPageNumbers = () => {
    const pages = [];
    const showEllipsis = totalPages > 7;

    pages.push(1);
    if (showEllipsis && currentPage > 4) pages.push("left-ellipsis");

    const start = Math.max(2, currentPage - 2);
    const end = Math.min(totalPages - 1, currentPage + 2);

    for (let i = start; i <= end; i++) pages.push(i);

    if (showEllipsis && currentPage < totalPages - 3) pages.push("right-ellipsis");
    if (totalPages > 1) pages.push(totalPages);

    return pages;
  };

  // ═══════════════════════════════════════════
  // 🔹 LOADING
  // ═══════════════════════════════════════════
  if (loading) {
    return (
      <div
        style={{
          minHeight: "80vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        }}
      >
        <div
          style={{
            width: "50px",
            height: "50px",
            border: "4px solid #e2e8f0",
            borderTop: "4px solid #1e5799",
            borderRadius: "50%",
            animation: "spin 0.8s linear infinite",
          }}
        />
        <style>{`@keyframes spin { from {transform:rotate(0deg);} to {transform:rotate(360deg);} }`}</style>
      </div>
    );
  }

  // ═══════════════════════════════════════════
  // 🎨 UI RENDER
  // ═══════════════════════════════════════════
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        padding: "24px",
        fontFamily: "'Poppins', 'DM Sans', sans-serif",
      }}
    >
      <div style={{ maxWidth: "1500px", margin: "0 auto" }}>
        <div
          style={{
            background: "#ffffff",
            borderRadius: "20px",
            boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
            border: "1.5px solid #e2e8f0",
            overflow: "hidden",
          }}
        >
          {/* Top Gradient */}
          <div
            style={{
              height: "5px",
              background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
            }}
          />

          {/* Header */}
          <div
            style={{
              padding: "24px 30px",
              background: "linear-gradient(135deg, #ffffff, #f8fafc)",
              borderBottom: "1.5px solid #e2e8f0",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "16px",
              flexWrap: "wrap",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
              <div
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "14px",
                  background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#ffffff",
                  fontSize: "22px",
                  boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
                  flexShrink: 0,
                }}
              >
                🏷️
              </div>
              <div>
                <h2
                  style={{
                    margin: 0,
                    fontSize: "22px",
                    fontWeight: "800",
                    color: "#1e3a5f",
                  }}
                >
                  Expense Categories
                </h2>
                <p
                  style={{
                    margin: "2px 0 0",
                    fontSize: "12.5px",
                    color: "#64748b",
                    fontWeight: "500",
                  }}
                >
                  Manage all expense categories ({totalItems} total)
                </p>
              </div>
            </div>

            <Link
              to="/add-category"
              style={{
                padding: "10px 18px",
                borderRadius: "10px",
                border: "none",
                background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                color: "#ffffff",
                fontSize: "13px",
                fontWeight: "700",
                textDecoration: "none",
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                boxShadow: "0 6px 18px rgba(30, 87, 153, 0.3)",
              }}
            >
              <FaPlus /> Add Category
            </Link>
          </div>

          {/* Body */}
          <div style={{ padding: "24px 30px" }}>
            {/* Error */}
            {error && (
              <div
                style={{
                  background: "#feeaeb",
                  border: "1.5px solid #fecaca",
                  color: "#991b1b",
                  borderRadius: "12px",
                  padding: "14px 18px",
                  marginBottom: "20px",
                  fontWeight: "600",
                  fontSize: "13.5px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <span>⚠️ {error}</span>
                <button
                  onClick={() => fetchCategories()}
                  style={{
                    padding: "6px 14px",
                    borderRadius: "8px",
                    border: "none",
                    background: "#dc2626",
                    color: "#ffffff",
                    fontWeight: "700",
                    fontSize: "12px",
                    cursor: "pointer",
                  }}
                >
                  Retry
                </button>
              </div>
            )}

            {/* Table */}
            {categories.length === 0 ? (
              <div
                style={{
                  textAlign: "center",
                  padding: "50px",
                  color: "#94a3b8",
                  fontWeight: "600",
                }}
              >
                📭 No expense categories found.
              </div>
            ) : (
              <>
                <div
                  style={{
                    overflowX: "auto",
                    overflowY: "visible",
                    borderRadius: "14px",
                    border: "1.5px solid #e2e8f0",
                  }}
                >
                  <table
                    style={{
                      width: "100%",
                      minWidth: "800px",
                      borderCollapse: "collapse",
                      fontSize: "13px",
                    }}
                  >
                    <thead>
                      <tr
                        style={{
                          background:
                            "linear-gradient(135deg, #1e5799, #2b6cb0)",
                        }}
                      >
                        {[
                          "S.N",
                          "Name",
                          "Category Type",
                          "Created At",
                          "Actions",
                        ].map((th, i) => (
                          <th
                            key={i}
                            style={{
                              padding: "14px 12px",
                              color: "#ffffff",
                              fontWeight: "700",
                              fontSize: "11.5px",
                              textAlign: "left",
                              letterSpacing: "0.5px",
                              textTransform: "uppercase",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {th}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {categories.map((category, index) => (
                        <tr
                          key={category.id}
                          style={{ borderBottom: "1px solid #f1f5f9" }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.background = "#f8fafc")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.background = "transparent")
                          }
                        >
                          <td style={cellBlue}>
                            {(currentPage - 1) * LIMIT + index + 1}
                          </td>
                          <td style={cellDark}>
                            {category.name
                              ? category.name.charAt(0).toUpperCase() +
                                category.name.slice(1).toLowerCase()
                              : "-"}
                          </td>
                          <td style={{ padding: "12px" }}>
                            <span
                              style={{
                                display: "inline-block",
                                padding: "4px 12px",
                                borderRadius: "20px",
                                fontSize: "11.5px",
                                fontWeight: "700",
                                background: "#e8f1fb",
                                color: "#1e5799",
                                textTransform: "capitalize",
                              }}
                            >
                              {category.type || "NA"}
                            </span>
                          </td>
                          <td style={{ ...cellGray, whiteSpace: "nowrap" }}>
                            {category.created_at
                              ? new Date(category.created_at)
                                  .toLocaleDateString("en-GB")
                                  .replace(/\//g, "-")
                              : "-"}
                          </td>
                          <td style={{ padding: "12px" }}>
                            <div className="dropdown">
                              <button
                                className="btn dropdown-toggle"
                                type="button"
                                data-bs-toggle="dropdown"
                                data-bs-boundary="viewport"
                                data-bs-popper-config='{"strategy":"fixed"}'
                                aria-expanded="false"
                                style={{
                                  background: "#f8fafc",
                                  border: "1.5px solid #e2e8f0",
                                  borderRadius: "8px",
                                  width: "36px",
                                  height: "36px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: "#1e5799",
                                  padding: 0,
                                }}
                              >
                                <BsThreeDots size={18} />
                              </button>
                              <ul
                                className="dropdown-menu"
                                style={{
                                  zIndex: 9999,
                                  borderRadius: "14px",
                                  border: "none",
                                  padding: "8px",
                                  boxShadow:
                                    "0 12px 40px rgba(30, 87, 153, 0.18), 0 4px 12px rgba(0,0,0,0.06)",
                                  minWidth: "230px",
                                  marginTop: "8px",
                                  background: "#ffffff",
                                }}
                              >
                                <li>
                                  <button
                                    className="dropdown-item d-flex align-items-center"
                                    onClick={() => handleEditClick(category)}
                                    style={dropdownItem}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.background =
                                        "#e7f9eb";
                                      e.currentTarget.style.transform =
                                        "translateX(3px)";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.background =
                                        "transparent";
                                      e.currentTarget.style.transform =
                                        "translateX(0)";
                                    }}
                                  >
                                    <span
                                      style={iconBadge("#e7f9eb", "#059669")}
                                    >
                                      <FaEdit size={13} />
                                    </span>
                                    Edit Category
                                  </button>
                                </li>

                                <li>
                                  <hr
                                    style={{
                                      margin: "6px 8px",
                                      border: "none",
                                      borderTop: "1.5px dashed #e2e8f0",
                                    }}
                                  />
                                </li>

                                <li>
                                  <button
                                    className="dropdown-item d-flex align-items-center"
                                    onClick={() => handleDeleteClick(category)}
                                    style={{
                                      ...dropdownItem,
                                      color: "#dc2626",
                                    }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.background =
                                        "#feeaeb";
                                      e.currentTarget.style.transform =
                                        "translateX(3px)";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.background =
                                        "transparent";
                                      e.currentTarget.style.transform =
                                        "translateX(0)";
                                    }}
                                  >
                                    <span
                                      style={iconBadge("#feeaeb", "#dc2626")}
                                    >
                                      <RiDeleteBin3Fill size={13} />
                                    </span>
                                    Delete Category
                                  </button>
                                </li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                {totalPages > 1 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "24px",
                      gap: "6px",
                      flexWrap: "wrap",
                    }}
                  >
                    <button
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                      style={{
                        padding: "8px 14px",
                        borderRadius: "10px",
                        border: "1.5px solid #e2e8f0",
                        background: "#ffffff",
                        color: currentPage === 1 ? "#cbd5e1" : "#1e5799",
                        fontWeight: "700",
                        fontSize: "13px",
                        cursor: currentPage === 1 ? "not-allowed" : "pointer",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      ‹ Prev
                    </button>

                    {getPageNumbers().map((p, i) => {
                      if (p === "left-ellipsis" || p === "right-ellipsis") {
                        return (
                          <span
                            key={`ellipsis-${i}`}
                            style={{
                              padding: "0 6px",
                              color: "#94a3b8",
                              fontWeight: "700",
                            }}
                          >
                            ...
                          </span>
                        );
                      }
                      const isActive = p === currentPage;
                      return (
                        <button
                          key={p}
                          onClick={() => handlePageChange(p)}
                          style={{
                            minWidth: "38px",
                            height: "38px",
                            borderRadius: "10px",
                            border: isActive
                              ? "none"
                              : "1.5px solid #e2e8f0",
                            background: isActive
                              ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                              : "#ffffff",
                            color: isActive ? "#ffffff" : "#334155",
                            fontWeight: "700",
                            fontSize: "13px",
                            cursor: "pointer",
                            boxShadow: isActive
                              ? "0 6px 16px rgba(30, 87, 153, 0.3)"
                              : "none",
                            transition: "all 0.18s ease",
                          }}
                        >
                          {p}
                        </button>
                      );
                    })}

                    <button
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                      style={{
                        padding: "8px 14px",
                        borderRadius: "10px",
                        border: "1.5px solid #e2e8f0",
                        background: "#ffffff",
                        color:
                          currentPage === totalPages ? "#cbd5e1" : "#1e5799",
                        fontWeight: "700",
                        fontSize: "13px",
                        cursor:
                          currentPage === totalPages
                            ? "not-allowed"
                            : "pointer",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      Next ›
                    </button>
                  </div>
                )}

                {totalItems > 0 && (
                  <p
                    style={{
                      textAlign: "center",
                      fontSize: "12px",
                      color: "#94a3b8",
                      marginTop: "12px",
                      marginBottom: 0,
                      fontWeight: "500",
                    }}
                  >
                    Page {currentPage} of {totalPages} • {totalItems} total
                    records
                  </p>
                )}
              </>
            )}
          </div>
        </div>

        {/* Footer */}
        <p
          style={{
            textAlign: "center",
            color: "#94a3b8",
            fontSize: "12.5px",
            marginTop: "24px",
            fontWeight: "500",
          }}
        >
          © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All Rights
          Reserved.
        </p>
      </div>

      {/* ═══════════════════════════════════════════ */}
      {/* 🎯 EDIT MODAL */}
      {/* ═══════════════════════════════════════════ */}
      <Modal
        show={editModalData.show}
        onHide={handleEditModalClose}
        centered
        backdrop="static"
        style={{ zIndex: 99999 }}
      >
        <Modal.Header
          closeButton
          style={{
            background: "#1e5799",
            color: "#ffffff",
            border: "none",
            padding: "18px 24px",
          }}
        >
          <Modal.Title style={{ fontWeight: "800", fontSize: "18px" }}>
            ✏️ Edit Category
          </Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleUpdateCategory}>
          <Modal.Body style={{ padding: "24px" }}>
            <Form.Group className="mb-3">
              <Form.Label style={labelStyle}>Category Name</Form.Label>
              <Form.Control
                type="text"
                value={editModalData.name}
                onChange={handleEditFormChange}
                required
                style={inputStyle}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer
            style={{
              borderTop: "1.5px solid #e2e8f0",
              padding: "16px 24px",
              gap: "10px",
            }}
          >
            <button
              type="button"
              onClick={handleEditModalClose}
              style={{
                padding: "10px 22px",
                borderRadius: "10px",
                border: "1.5px solid #e2e8f0",
                background: "#ffffff",
                color: "#64748b",
                fontSize: "13px",
                fontWeight: "700",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={actionLoading}
              style={{
                padding: "10px 22px",
                borderRadius: "10px",
                border: "none",
                background: actionLoading
                  ? "#cbd5e1"
                  : "linear-gradient(135deg, #1e5799, #2b6cb0)",
                color: "#ffffff",
                fontSize: "13px",
                fontWeight: "700",
                cursor: actionLoading ? "not-allowed" : "pointer",
                boxShadow: actionLoading
                  ? "none"
                  : "0 4px 12px rgba(30, 87, 153, 0.3)",
              }}
            >
              {actionLoading ? "Updating..." : "Save Changes"}
            </button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* ═══════════════════════════════════════════ */}
      {/* 🎯 DELETE MODAL */}
      {/* ═══════════════════════════════════════════ */}
      <Modal
        show={deleteModalData.show}
        onHide={handleDeleteModalClose}
        centered
        backdrop="static"
        style={{ zIndex: 99999 }}
      >
        <Modal.Header
          closeButton
          style={{
            background: "#dc2626",
            color: "#ffffff",
            border: "none",
            padding: "18px 24px",
          }}
        >
          <Modal.Title style={{ fontWeight: "800", fontSize: "18px" }}>
            ⚠️ Confirm Deletion
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            padding: "24px",
            fontSize: "14px",
            color: "#334155",
            textAlign: "center",
          }}
        >
          <div style={{ fontSize: "40px", marginBottom: "12px" }}>🗑️</div>
          <p style={{ margin: 0, fontWeight: "600" }}>
            Are you sure you want to delete the category{" "}
            <strong>"{deleteModalData.name}"</strong>? This action cannot be
            undone.
          </p>
        </Modal.Body>
        <Modal.Footer
          style={{
            borderTop: "1.5px solid #e2e8f0",
            padding: "16px 24px",
            gap: "10px",
            justifyContent: "center",
          }}
        >
          <button
            type="button"
            onClick={handleDeleteModalClose}
            disabled={actionLoading}
            style={{
              padding: "10px 22px",
              borderRadius: "10px",
              border: "1.5px solid #e2e8f0",
              background: "#ffffff",
              color: "#64748b",
              fontSize: "13px",
              fontWeight: "700",
              cursor: actionLoading ? "not-allowed" : "pointer",
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleDeleteCategory}
            disabled={actionLoading}
            style={{
              padding: "10px 22px",
              borderRadius: "10px",
              border: "none",
              background: actionLoading
                ? "#cbd5e1"
                : "linear-gradient(135deg, #dc2626, #b91c1c)",
              color: "#ffffff",
              fontSize: "13px",
              fontWeight: "700",
              cursor: actionLoading ? "not-allowed" : "pointer",
              boxShadow: actionLoading
                ? "none"
                : "0 4px 12px rgba(220, 38, 38, 0.3)",
            }}
          >
            {actionLoading ? "Deleting..." : "Yes, Delete"}
          </button>
        </Modal.Footer>
      </Modal>

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

// ═══════════════════════════════════════════
// 🎨 SHARED STYLES
// ═══════════════════════════════════════════
const labelStyle = {
  display: "block",
  fontSize: "12.5px",
  fontWeight: "700",
  color: "#1e3a5f",
  marginBottom: "6px",
};

const inputStyle = {
  width: "100%",
  padding: "10px 14px",
  borderRadius: "10px",
  border: "1.5px solid #e2e8f0",
  fontSize: "13.5px",
  fontWeight: "500",
  color: "#1e3a5f",
  outline: "none",
  boxSizing: "border-box",
};

const cellBlue = { padding: "12px", fontWeight: "700", color: "#1e5799" };
const cellDark = { padding: "12px", fontWeight: "600", color: "#1e3a5f" };
const cellGray = { padding: "12px", color: "#64748b" };

const dropdownItem = {
  padding: "9px 12px",
  borderRadius: "10px",
  fontSize: "13px",
  fontWeight: "600",
  gap: "10px",
  transition: "all 0.18s ease",
  marginBottom: "2px",
  border: "none",
  background: "transparent",
  width: "100%",
  textAlign: "left",
  color: "#1e5799",
};

const iconBadge = (bg, color) => ({
  width: "28px",
  height: "28px",
  borderRadius: "8px",
  background: bg,
  color: color,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
});

export default CategoryList;
